// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { chatSessionsId } from './ChatSessions';
import { chatMessageRoleEnum } from './ChatMessageRoleEnum';
import { chatMessageStatusEnum } from './ChatMessageStatusEnum';
import { z } from 'zod';
export const chatMessageId = (z.string());
export const chatMessage = z.object({
    id: chatMessageId,
    chat_session_id: chatSessionsId,
    message_order: z.number(),
    role: chatMessageRoleEnum,
    content: z.string().nullable(),
    metadata: z.unknown().nullable(),
    status: chatMessageStatusEnum,
    created_at: z.date(),
    updated_at: z.date(),
});
export const chatMessageInitializer = z.object({
    id: chatMessageId.optional(),
    chat_session_id: chatSessionsId,
    message_order: z.number(),
    role: chatMessageRoleEnum,
    content: z.string().optional().nullable(),
    metadata: z.unknown().optional().nullable(),
    status: chatMessageStatusEnum.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const chatMessageMutator = z.object({
    id: chatMessageId.optional(),
    chat_session_id: chatSessionsId.optional(),
    message_order: z.number().optional(),
    role: chatMessageRoleEnum.optional(),
    content: z.string().optional().nullable(),
    metadata: z.unknown().optional().nullable(),
    status: chatMessageStatusEnum.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=ChatMessage.js.map